<template>
  <div
    class="modal fade premium-modal"
    id="premiumModal"
    tabindex="-1"
    aria-labelledby="premiumModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeButton"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Подписка Premium уже подключена</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "PremiumModal",
  setup() {
    let modalInstance = null;

    const openModal = () => {
      if (modalInstance) {
        modalInstance.show();
      }
    };

    onMounted(() => {
      const modalElement = document.getElementById("premiumModal");
      if (modalElement) {
        modalInstance = new Modal(modalElement);
      } else {
        console.error("Модальное окно не найдено");
      }
    });

    return {
      openModal,
    };
  },
});
</script>

<style scoped>
.form-label {
  display: flex;
  justify-content: center;
}
</style>
